(function () {
  const mq = window.matchMedia('(max-width: 749px)');
  let klarna, originalParent, originalNext, moving = false;

  const CUSTOM_LINK_CSS =
    ".link, a, a.link, a:link, a:visited, button.link, [class*='link'] { font-family: 'Inter', sans-serif !important; font-weight: 400 !important; font-size: 10px !important; line-height: 18px !important; letter-spacing: 0 !important; color: #686868 !important; text-decoration: underline !important; } .link:hover, a:hover { color: #444 !important; }";

  function injectShadowStyle() {
    document.querySelectorAll('klarna-placement').forEach((p) => {
      if (!p.shadowRoot) return;
      if (p.shadowRoot.querySelector('style[data-custom-osm]')) return;
      const s = document.createElement('style');
      s.setAttribute('data-custom-osm', '');
      s.textContent = CUSTOM_LINK_CSS;
      p.shadowRoot.appendChild(s);
    });
  }

  function ensurePosition() {
    if (!klarna || moving) return;
    // Anchor on the whole price row, not on `.price` inside it. Inserting after `.price`
    // dropped the Klarna block between the sale price and the compare-at price, which is
    // what pushed the crossed-out price onto its own line.
    const sticky = document.querySelector('.sticky-add-to-cart__price');
    moving = true;
    try {
      if (mq.matches && sticky) {
        if (sticky.nextSibling !== klarna) {
          sticky.insertAdjacentElement('afterend', klarna);
        }
      } else if (!mq.matches && originalParent && originalParent.isConnected) {
        if (klarna.parentElement !== originalParent || klarna.nextSibling !== originalNext) {
          originalParent.insertBefore(klarna, originalNext);
        }
      }
    } catch (e) {}
    moving = false;
  }

  function captureKlarna() {
    if (klarna) return true;
    const kl = document.querySelector('.shopify-block:has(klarna-placement)');
    if (!kl) return false;
    klarna = kl;
    originalParent = kl.parentElement;
    originalNext = kl.nextSibling;
    return true;
  }

  let klarnaRo = null;
  function watchKlarnaSize() {
    if (klarnaRo) return;
    const el = document.querySelector('klarna-placement');
    if (!el) return;
    const shopifyBlock = el.closest('.shopify-block');
    if (!shopifyBlock) return;
    const groupContent = shopifyBlock.closest('.group-block-content');
    if (!groupContent) return;
    // Never apply the column fallback to the sticky bar: its price row must stay on one
    // line so the sale price and the compare-at price read as a pair.
    if (groupContent.closest('.sticky-add-to-cart')) return;

    function checkLayout() {
      var siblingWidth = 0;
      for (var i = 0; i < groupContent.children.length; i++) {
        var child = groupContent.children[i];
        if (child && child !== shopifyBlock && !child.contains(el)) {
          siblingWidth += child.getBoundingClientRect().width;
        }
      }
      var available = groupContent.offsetWidth - siblingWidth - 4;
      if (available > 0 && available < 295) {
        groupContent.style.flexDirection = 'column';
        groupContent.style.alignItems = 'flex-start';
        groupContent.style.gap = '0px';
      } else if (available >= 295) {
        groupContent.style.flexDirection = '';
        groupContent.style.alignItems = '';
        groupContent.style.gap = '';
      }
    }

    klarnaRo = new ResizeObserver(checkLayout);
    klarnaRo.observe(groupContent);
    window.addEventListener('resize', checkLayout);
    checkLayout();
  }

  function start() {
    captureKlarna();
    ensurePosition();
    injectShadowStyle();
    watchKlarnaSize();
    const obs = new MutationObserver(() => {
      captureKlarna();
      ensurePosition();
      injectShadowStyle();
      watchKlarnaSize();
    });
    obs.observe(document.body, { childList: true, subtree: true });
    mq.addEventListener('change', ensurePosition);
    window.addEventListener('load', ensurePosition);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
